import firebase from 'firebase/app';
import { Tag } from './Tag';

export enum REACTION_SINAL {
  POSITIVO, NEGATIVO
}

interface Votes {
  up: number,
  down: number
}

export class Word {
  constructor(
    public text: string = '',
    public state: string = '',
    public grammar: string = '',
    public synonymous: string = '',
    public signalRight: string = '',
    public signalLeft: string = '',
    public urlYoutube: string = '',
    public videoFile: string = '',
    public owner: string = '',
    public votes: Votes = {
      up: 0,
      down: 0
    },
    public tags: Array<Tag> = [],
    public category: string | null = null,
    public createdIn = firebase.firestore.Timestamp.now(),
    public key: string = '',
  ) { }


  diffVotes(): number {
    return this.votes.up - this.votes.down
  }

  get hasVideo() {
    return Boolean(this.urlYoutube || this.videoFile)
  }
}
